import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppWidget = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isPulsing, setIsPulsing] = useState(true);
    
    const phoneNumber = '923329754400';
    const message = encodeURIComponent('Hello, I would like to inquire about legal services.');

    // Set the widget to visible after a small delay for a nice entrance effect
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 1000);
        
        return () => clearTimeout(timer);
    }, []);
    
    // Add a recurring pulse animation every few seconds
    useEffect(() => {
        const pulseInterval = setInterval(() => {
            setIsPulsing(true);
            setTimeout(() => setIsPulsing(false), 2000);
        }, 8000);
        
        return () => clearInterval(pulseInterval);
    }, []);

    const handleButtonClick = () => {
        if (isOpen) {
            setIsOpen(false);
        } else {
            setIsPulsing(false);
            setIsOpen(true);
        }
    };

    const handleWhatsAppClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(url, '_blank');
    };

    return (
        <div className={`fixed bottom-8 right-8 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'}`}>
            {/* WhatsApp Popup */}
            {isOpen && (
                <div className="bg-white rounded-lg shadow-xl mb-4 overflow-hidden w-72 transform transition-all duration-300 scale-100">
                    <div className="bg-green-500 p-4 flex justify-between items-center">
                        <div className="flex items-center text-white">
                            <MessageCircle className="w-6 h-6 mr-2" />
                            <span className="font-medium">Chat with us</span>
                        </div>
                        <button 
                            onClick={() => setIsOpen(false)}
                            className="text-white hover:text-green-100 focus:outline-none"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                    <div className="p-4">
                        <p className="text-gray-700 mb-4">
                            Hi there! 👋<br />
                            Need legal assistance? Chat with us on WhatsApp for a quick response.
                        </p>
                        <button
                            onClick={handleWhatsAppClick}
                            className="w-full bg-green-500 hover:bg-green-600 text-white py-3 px-4 rounded-md flex items-center justify-center font-medium transition-colors"
                        >
                            <MessageCircle className="w-5 h-5 mr-2" />
                            Start Chat
                        </button>
                    </div>
                </div>
            )}
            
            {/* WhatsApp Button */}
            <button
                onClick={handleButtonClick}
                className={`relative bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 ${
                    isPulsing ? 'animate-pulse' : ''
                }`}
                aria-label="Chat on WhatsApp"
            >
                {/* Ripple Effect */}
                <span className={`absolute inset-0 rounded-full ${
                    isPulsing ? 'animate-ping' : 'opacity-0'
                } bg-green-400 opacity-75`}></span>
                
                {/* Main Icon */}
                <MessageCircle className={`w-6 h-6 ${isOpen ? 'rotate-0' : 'animate-bounce'}`} />
                
                {/* Notification Dot */}
                <span className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full border-2 border-white"></span>
            </button>
        </div>
    );
};

export default WhatsAppWidget;